/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CIconButton.vue?vue&type=template&id=2abb33d1"
import script from "./CIconButton.vue?vue&type=script&lang=ts"
export * from "./CIconButton.vue?vue&type=script&lang=ts"
import style0 from "./CIconButton.vue?vue&type=style&index=0&id=2abb33d1&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports